import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const EL = '.js-partners-carousel';

document.querySelectorAll(EL).forEach((carousel) => {
  new Splide(carousel, {
    type: 'loop',
    arrows: false,
    pagination: false,
    drag: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    autoWidth: true,
    gap: 80,
    breakpoints: {
      767: {
        gap: 30,
      },
    },
    autoScroll: {
      speed: 1,
      pauseOnHover: false,
      pauseOnFocus: false,
    },
  }).mount({AutoScroll});
});
